import styled from "styled-components";

export const BgFigure = styled.div<{ $isRight?: boolean }>`
  position: absolute;
  z-index: 2;
  ${(props) =>
    props.$isRight
      ? "right: 0; top: -37px; width: 260px; height: 300px"
      : "left: -22px; bottom: 0; width: 265px; height: 230px"};

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  };
`;
